// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Loaded, Loadable, LoadingStatus } from '@app/core';
import { GroupsActionTypes, GroupsActions } from './groups.actions';
import { Group } from '../../core/models/groups.model';

export type GroupsState = Loaded<Group[]> | Loadable;

export function groupsReducer(state: Readonly<GroupsState>, action: GroupsActions): Readonly<GroupsState> {
  switch (action.type) {
    case GroupsActionTypes.GROUPS_LOADING:
      return {
        status: LoadingStatus.LOADING
      };

    case GroupsActionTypes.GROUPS_LOAD_COMPLETE:
      return {
        data: action.payload,
        status: LoadingStatus.LOAD_COMPLETE
      };

    case GroupsActionTypes.GROUPS_LOAD_FAILED:
      return {
        status: LoadingStatus.LOAD_FAILED
      };

    case GroupsActionTypes.GROUPS_REMOVE_BY_ID:
      return {
        data: state ? filterById(state.data, action.payload) : state,
        status: LoadingStatus.LOAD_COMPLETE
      };
  }
  return state;
}

export function filterById(data: Group[], removedId: string): Group[] {
  return data.filter(group => group.group_id !== removedId);
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/groups/groups.reducer.ts